import { RemoteGetCompletedAndMissedActivitiesCount } from 'data/usecases/dashboard';
import { GetCompletedAndMissedActivitiesCount } from 'domain/usecases/dashboard';
import { makeApiUrlCompletedAndMissedActivitiesCount } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetCompletedAndMissedActivitiesCount =
  (): GetCompletedAndMissedActivitiesCount =>
    new RemoteGetCompletedAndMissedActivitiesCount(
      makeApiUrlCompletedAndMissedActivitiesCount(),
      makeAxiosHttpClient(),
    );
